import {
  CandidateUI,
  FetchMatchCandidatesRequestParams,
  FetchMatchCandidatesResponse,
  LikesQuota
} from '@/api/matchmaker/types.ts';
import { apiUrls } from '@/api/api-urls.ts';
import Api from '@/api/config.ts';
import { helpers } from '@/helpers.ts';

const fetchMatchCandidates = async ({
  limit,
  ...body
}: FetchMatchCandidatesRequestParams): Promise<CandidateUI[]> => {
  const response = await Api.post<FetchMatchCandidatesResponse>(
    apiUrls.matchmaker.users(limit),
    body
  );

  return response.data.hits.map((item) => helpers.mapToDiscoveryModel(item));
};

const likeMatchCandidate = async (hid: string) => {
  const response = await Api.post<{
    result: boolean;
    likes_quota: LikesQuota | null;
  }>(apiUrls.matchmaker.like(hid));

  return response.data.likes_quota;
};

const passMatchCandidate = async (hid: string): Promise<void> => {
  await Api.post<{ result: boolean }>(apiUrls.matchmaker.pass(hid));
};

const MatchMakerService = {
  fetchMatchCandidates,
  passMatchCandidate,
  likeMatchCandidate
};

export default MatchMakerService;
